import { useToast } from "vue-toastify";
import type { AppWithI18n } from "@/types/appWithI18n";

const NETWORK_ERROR_TOAST_DURATION = 10000;

let connectionErrorToast: string | null = null;

export const showNetworkConnectionToast = (app: AppWithI18n): void => {
  const t = app.__VUE_I18N__.global.t;
  if (connectionErrorToast) {
    return;
  }
  connectionErrorToast = useToast().warning({
    title: t("error.warningTitle"),
    body: t("error.networkError"),
    duration: NETWORK_ERROR_TOAST_DURATION,
  });
  setTimeout(() => (connectionErrorToast = null), NETWORK_ERROR_TOAST_DURATION);
};
